import { render, staticRenderFns } from "./regionalConfig.vue?vue&type=template&id=0d6fd933&scoped=true&"
import script from "./regionalConfig.vue?vue&type=script&lang=js&"
export * from "./regionalConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d6fd933",
  null
  
)

export default component.exports